import { render, staticRenderFns } from "./statusMessage.vue?vue&type=template&id=b4e0a28a"
import script from "./statusMessage.vue?vue&type=script&lang=js"
export * from "./statusMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports